import(/* webpackMode: "eager" */ "/home/circleci/project/src/app/global-error.tsx");
